import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n-lite';
import DrawerCommonPanel from './DrawerCommonPanel';
import { getGoogleClassroomCourses, shareContentInGoogleClassroom } from '../../utils/google/GClassroomUtils';
import * as drawerActions from '../../actions/drawerActions';
import * as messageAlert from '../../actions/messageAlertAction';
import * as googleClassroomActions from '../../actions/googleClassroomActions';
import RadioContainer from '../library/RadioContainer';
import google_classroom_icon from '../../images/google_classroom_icon.svg';
import { translateObject } from '../../services/translate/customTranslateService';
import { CONTEXT_PATH } from '../../config_module';
import { CircularProgress } from '@material-ui/core';
import { arePermissionsGranted, requestPermissions } from '../../utils/google/googleUtils';
import { GOOGLE_CLASSROOM_SCOPES } from '../../const';

class SelectGoogleCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courses: [],
      selectedCourseId: '',
      askedForGapi: false,
      sharingInProgress: false,
      loading: true,
      permissionsGiven: true
    };
  }

  async componentDidMount() {
    const isGranted = await arePermissionsGranted(GOOGLE_CLASSROOM_SCOPES);
    if (isGranted) {
      this.setGoogleClassrooms();
    } else {
      await requestPermissions(
        GOOGLE_CLASSROOM_SCOPES,
        () => {
          this.setGoogleClassrooms();
        },
        () => {
          this.setState({ loading: false, askedForGapi: true, permissionsGiven: false });
          this.props.messageAlert.error(I18n.t('panels.google.noScopes'));
        }
      );
    }
  }

  setGoogleClassrooms() {
    getGoogleClassroomCourses()
      .then(courses => {
        this.setState({ courses: courses ? courses : [], askedForGapi: true, loading: false, permissionsGiven: true });
      })
      .catch(error => {
        this.setState({ loading: false, permissionsGiven: false });
        this.props.messageAlert.error(error.message);
      });
  }

  closeDrawer = () => {
    googleClassroomActions.clearContent();
    googleClassroomActions.clearCourseId();
    this.props.drawerActions.setDrawerClosed();
  };

  shareContentOnGoogleClassroom = async () => {
    this.setState({ sharingInProgress: true });
    const { content, contentType, messageAlert, sectionId, institutionId } = this.props;
    const courseId = this.state.selectedCourseId;
    shareContentInGoogleClassroom(contentType, content, courseId, sectionId, institutionId);
    messageAlert.info(I18n.t('panels.google.sharingInProgress'));
    this.closeDrawer();
  };

  render() {
    const { content, language } = this.props;

    return (
      <DrawerCommonPanel
        sticky={false}
        panelHeaderTitle={<Translate value="common.option.shareInGoogleClassroom" dangerousHTML />}
        showCancelButton={false}
        hideRowButtons={false}
        primaryButtonText={'panels.google.accept'}
        closePanel={this.closeDrawer}
        disableButtons={this.state.selectedCourseId === '' || this.state.sharingInProgress}
        onPrimaryButtonClick={this.shareContentOnGoogleClassroom}
      >
        <div className="share-google-classroom-logo-container">
          <img src={`${CONTEXT_PATH}${google_classroom_icon}`} alt="Google Classroom logo" />
        </div>

        <div className="share-google-classroom-text-container">
          <Translate value="panels.google.selectCourseTitle" name={translateObject(content.name, language)} />
          <Translate value="panels.google.selectCourseToShare" />
        </div>

        {!this.state.loading && this.state.permissionsGiven && (
          <div style={{ marginTop: '5px', marginLeft: '15px' }}>
            {this.state.courses.map((course, i) => {
              const courseText = course.name + (course.section ? ` (${course.section})` : '');
              return (
                <RadioContainer
                  className={'cookies-info-container'}
                  key={i}
                  checkId={courseText}
                  checked={this.state.selectedCourseId === course.id}
                  onCheck={() => this.setState({ selectedCourseId: course.id })}
                />
              );
            })}
            {this.state.courses.length === 0 && <p>{I18n.t('panels.google.noClassroomsFound')}</p>}
          </div>
        )}
        {!this.state.loading && !this.state.permissionsGiven && (
          <div style={{ marginTop: '5px', marginLeft: '15px' }}>
            <p>{I18n.t('panels.google.grantPermissions')}</p>
          </div>
        )}
        {this.state.loading && (
          <div className="select-course-loader">
            <CircularProgress />
          </div>
        )}
      </DrawerCommonPanel>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: state.googleClassroom.content,
    contentType: state.googleClassroom.contentType,
    sectionId: state.router.params.idClassroom,
    language: state.account.user.language,
    institutionId: state.account.user.institutionId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    drawerActions: bindActionCreators(drawerActions, dispatch),
    googleClassroomActions: bindActionCreators(googleClassroomActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectGoogleCourse);
